<template>
    <div style="margin: 10px" class="balance-card-batch">
        <CardDataBatch :cardType="1"></CardDataBatch>
    </div>
</template>
<script>
//导入 HTTP请求方法
import CardDataBatch from '@/components/card/BalanceCardBatch.vue'

export default {
    data() {
        return {

        }
    },
    components: {CardDataBatch},
    //挂载时候执行
    mounted(){

    },

    methods: {}
}
</script>
<style lang="scss">
.balance-card-batch{
    .el-input-number .el-input__inner{
        text-align: left;
    }
    .el-drawer__header{
        margin-bottom: 15px;
    }
}

</style>


// WEBPACK FOOTER //
// src/views/giftCard/BalanceCardBatch.vue